module.exports = __webpack_public_path__ + "static/media/a22.9b1f02fb.jpg";